import React from 'react';

import { NumberFields } from 'jbc-front/components/Form';

const OrganizationSymbol = ({ required }) => (
  <NumberFields
    label="厚生年金保険記号（事業所整理記号）"
    texts={['', ' - ']}
    lengths={[2, 4]}
    required={required}
    seperateChar=""
    needNumber={false}
    prefix="organizationSymbolPart"
    note="「数字2ケタ-カタカナまたは英数4ケタ以内」の形式です。年金事務所から送付された納付告知書などに記載されています。"
  />
);

export default OrganizationSymbol;
